import { FC } from 'react'
import LazyLoad from 'react-lazyload'
import JourneySection from '~/components/LandingPage/JourneySection'
import LayoutLandingPage from '~/components/Layout/LayoutLandingPage'
import BenefitSection from '~/components/Solutions/BenefitSection'
import CompetitiveSection from '~/components/Solutions/CompetitiveSection'
// import CustomerSection from '~/components/Solutions/CustomerSection'
import GrowSection from '~/components/Solutions/GrowSection'
import SkillsFoundationSection from '~/components/Solutions/SkillsFoundationSection'
import SolutionsEnterpriseSection from '~/components/Solutions/SolutionsEnterpriseSection'
import WhySection from '~/components/Solutions/WhySection'

const LazyLoadWrapper = LazyLoad as unknown as FC<any>

const SolutionsEnterpriseContainer = () => {
  return (
    <LayoutLandingPage>
      <SolutionsEnterpriseSection />

      <LazyLoadWrapper height={300} once>
        <WhySection />
      </LazyLoadWrapper>

      {/* <LazyLoad height={300} once>
        <CustomerSection />
      </LazyLoad> */}

      <LazyLoadWrapper height={300} once>
        <SkillsFoundationSection />
      </LazyLoadWrapper>

      <LazyLoadWrapper height={300} once>
        <CompetitiveSection />
      </LazyLoadWrapper>

      <LazyLoadWrapper height={300} once>
        <BenefitSection />
      </LazyLoadWrapper>

      <LazyLoadWrapper height={300} once>
        <GrowSection />
      </LazyLoadWrapper>

      <LazyLoadWrapper height={300} once>
        <JourneySection className="desktop:mt-[140px] desktop:mb-[0px] bg-gray-50 mt-[64px] my-[0px] py-[64px]" />
      </LazyLoadWrapper>
    </LayoutLandingPage>
  )
}

export default SolutionsEnterpriseContainer
